var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{staticClass:"img_uploader",attrs:{"list-type":"picture-card","action":_vm.apis.uploadUrl,"show-file-list":_vm.multi,"on-remove":_vm.removed,"before-upload":_vm.beforeUpload}},[_c('i',{staticClass:"el-icon-plus"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce8c569","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/view/cmps/upload/imgs/src/imgs.vue
// module id = null
// module chunks = 